import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import DataTable from "@components/common/DataTable";
// import { EventDetailProps } from "../../homepage/aml-anomaly-detection/AmlAnomalyTypes";
import { useQuery } from "react-query";
import { getEventDetail } from "@services/api/commonApis";
import TableLoader from "@components/loaders/TableLoader";
import { sanitizeHtml } from "@utils/utils";
interface EventDataProp {
  eventDetails?: any;
  apiProps?: any;
  isOpen: boolean;
  onClose: () => void;
}

const EventData: React.FC<EventDataProp> = ({
  eventDetails,
  apiProps,
  isOpen = false,
  onClose,
}) => {
  const eventCols = [
    { header: "Event ID", accessor: "EventId" },
    { header: "Event Name", accessor: "EventName" },
    { header: "Anomalous Mac", accessor: "AnomalousIpMac" },
    { header: "Source IP", accessor: "sip" },
    { header: "Source Mac", accessor: "smac" },
    { header: "Destination IP", accessor: "dip" },
    { header: "Destination Mac", accessor: "dmac" },
  ];

  const userCols = [
    { header: "Event ID", accessor: "EventId" },
    { header: "Event Name", accessor: "EventName" },
    { header: "User ID", accessor: "userid" },
    { header: "Workstation IP", accessor: "wip" },
    { header: "Workstation Name", accessor: "wname" },
    { header: "Log Source", accessor: "log_source" },
  ];

  const [eventTableData, setEventTableData] = React.useState<any>([]);
  const [displayFieldCols, setDisplayFieldCols] = React.useState<any>([]);
  const [displayFieldRows, setDisplayFieldRows] = React.useState<any>([]);
  const [rawTableData, setRawTableData] = React.useState<any>([]);
  const [logCols, setLogCols] = React.useState<any>([]);

  const { data: EventApiData, isLoading } = useQuery(
    ["getEventDetail", apiProps?.eventGid],
    ({ signal }) => getEventDetail(apiProps || {}, signal),
    {
      enabled: !!apiProps,
    },
  );

  React.useEffect(() => {
    if (EventApiData && EventApiData.length > 0) {
      const eventData = EventApiData[0].EventData;
      const event = [
        {
          ...EventApiData[0],
          sip: eventData.sip || "- - -",
          smac: eventData.smac || "- - -",
          dip: eventData.dip || "- - -",
          dmac: eventData.dmac || "- - -",
          userid: eventData.Username || "- - -",
          log_source: eventData.log_source.join(", ") || "- - -",
          wip: eventData.IP || "- - -",
          wname: eventData.WorkstationName || "- - -",
        },
      ];

      const display: any = {};
      const displayCol: any = [];
      if ("display" in eventData) {
        Object.entries(eventData.display).map(([key, val]) => {
          display[key] = sanitizeHtml(val as string);
          displayCol.push({
            header: key,
            accessor: key,
          });
        });
      }

      setDisplayFieldCols(displayCol);
      setDisplayFieldRows([display]);
      setEventTableData(event);
      setLogCols(
        EventApiData.length > 0 && EventApiData[0]["UsecaseType"] === "user"
          ? userCols
          : eventCols,
      );

      let rawMessage: any = {};
      const parsedEventData = eventData;
      if (parsedEventData) {
        // If object has propery data, then get raw_message from it else check if it has Data property
        if (parsedEventData.data) {
          rawMessage = parsedEventData.data.raw_message[0] || {};
        } else if (parsedEventData.Data) {
          rawMessage = parsedEventData.Data.raw_message[0] || {};
        }
      }

      const rawRows = Object.entries(rawMessage).map(([key, val]) => {
        const _val = val === null ? "-" : String(val);
        return {
          Field: key,
          Value:
            (_val as string)?.trim() != ""
              ? sanitizeHtml(_val as string)
              : "- - -",
        };
      });

      setRawTableData(rawRows);
    }
  }, [EventApiData]);

  React.useEffect(() => {
    if (eventDetails) {
      const eventData = JSON.parse(eventDetails.EventData);
      const event = [
        {
          ...eventDetails,
          sip: eventData.sip,
          smac: eventData.smac,
          dip: eventData.dip,
          dmac: eventData.dmac,
          userid: eventData.Username || "",
          log_source: eventData.log_source.join(", ") || "",
          wip: eventData.IP || "- - -",
          wname: eventData.WorkstationName || "- - -",
        },
      ];
      setEventTableData(event);
      setLogCols(eventDetails["UsecaseType"] === "user" ? userCols : eventCols);
      if ("Data" in eventData) {
        setLogCols(userCols);
      }

      let rawMessage: any = {};
      const parsedEventData = eventData;
      if (parsedEventData) {
        // If object has propery data, then get raw_message from it else check if it has Data property
        if (parsedEventData.data) {
          rawMessage = parsedEventData.data.raw_message[0] || {};
        } else if (parsedEventData.Data) {
          rawMessage = parsedEventData.Data.raw_message[0] || {};
        }

        const display: any = {};
        const displayCol: any = [];
        if ("display" in parsedEventData) {
          Object.entries(parsedEventData.display).map(([key, val]) => {
            display[key] = sanitizeHtml(val as string);
            displayCol.push({
              header: key,
              accessor: key,
            });
          });
          setDisplayFieldCols(displayCol);
          setDisplayFieldRows([display]);
        }
      }

      const rawRows = Object.entries(rawMessage).map(([key, val]) => {
        return {
          Field: key,
          Value:
            (val as string).trim() != ""
              ? sanitizeHtml(val as string)
              : "- - -",
        };
      });

      setRawTableData(rawRows);
    }
  }, [eventDetails]);

  const rawCols = [
    { header: "Field", accessor: "Field" },
    { header: "Value", accessor: "Value" },
  ];

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[50vw]">
        <DialogHeader>
          <DialogTitle>Event Details</DialogTitle>
          <DialogDescription>
            {/* Make changes to your profile here. Click save when you're done. */}
          </DialogDescription>
        </DialogHeader>
        {isLoading ? (
          <TableLoader colCount={7} />
        ) : (
          <DataTable
            search={false}
            cols={logCols}
            data={eventTableData}
            colFilter={false}
            countPerPageSelection={false}
            pagination={false}
            allowXScroll
          />
        )}
        {displayFieldRows.length > 0 && (
          <div>
            <div className="font-bold text-lg mb-4">Display Fields</div>
            {isLoading ? (
              <TableLoader colCount={2} />
            ) : (
              <div className="max-h-[45vh] overflow-y-auto">
                <DataTable
                  cols={displayFieldCols}
                  data={displayFieldRows}
                  colFilter={false}
                  countPerPageSelection={false}
                  pagination={false}
                  search={false}
                />
              </div>
            )}
          </div>
        )}
        <div className="font-bold text-lg">Raw Message</div>
        {isLoading ? (
          <TableLoader colCount={2} />
        ) : (
          <div className="max-h-[45vh] overflow-y-auto">
            <DataTable
              cols={rawCols}
              data={rawTableData}
              colFilter={false}
              countPerPageSelection={false}
              totalCount={rawTableData.length}
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EventData;
